<script setup lang="ts">
import CountUp from "vue-countup-v3";

interface Props {
    value: number;
    delay: number;
}
const props = defineProps<Props>();

const options = {
    enableScrollSpy: true,
    scrollSpyOnce: true,
    scrollSpyDelay: props.delay,
    separator: ".",
};
</script>

<template>
    <count-up :end-val="value" :autoplay="false" :options="options"></count-up>
</template>
